import { useEffect, useState } from "react";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  TextField,
} from "@mui/material";

const PROMPTS = {
  RESOLVED: "Mark this ticket resolved? The conversation closes until someone reopens it.",
  CANCELLED: "Cancel this ticket? The conversation closes until someone reopens it.",
  LOCKED:
    "Lock this ticket? The conversation closes and only the office can reopen it; the partner cannot.",
  OPEN: "Reopen this ticket so the conversation can continue?",
};

/** Every status change is confirmed first, with room for a note that goes on the record. */
const StatusChangeDialog = ({ action, busy, onCancel, onConfirm }) => {
  const [note, setNote] = useState("");
  useEffect(() => setNote(""), [action]);

  return (
    <Dialog open={Boolean(action)} onClose={busy ? undefined : onCancel} fullWidth maxWidth="sm">
      <DialogTitle>{action?.label}</DialogTitle>
      <DialogContent>
        <DialogContentText sx={{ mb: 2 }}>{PROMPTS[action?.to]}</DialogContentText>
        <TextField
          fullWidth
          multiline
          minRows={2}
          size="small"
          label="Note (optional)"
          value={note}
          inputProps={{ maxLength: 2000 }}
          onChange={(event) => setNote(event.target.value)}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={onCancel} disabled={busy}>
          Back
        </Button>
        <Button
          variant="contained"
          color={action?.color || "primary"}
          disabled={busy}
          onClick={() => onConfirm(note.trim())}
        >
          {busy ? "Saving…" : action?.label}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default StatusChangeDialog;
